import DOMPurify from 'isomorphic-dompurify';
import React from 'react';
import { useEffect } from 'react';

interface MinimalTiptapEditorViewerProps {
  contents: string;
  fallback?: React.ReactNode;
}

const EDITOR_CLASS_NAME = 'minimal-tiptap-editor';
const PROSEMIRROR_CLASS_NAME = 'ProseMirror';

const _useStylesheet = (path: string) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const id = `stylesheet-${path}`;
    const existingLink = document.getElementById(id);

    if (!existingLink) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = path;
      document.head.appendChild(link);

      return () => {
        const linkToRemove = document.getElementById(id);
        if (linkToRemove) {
          document.head.removeChild(linkToRemove);
        }
      };
    }

    return undefined;
  }, [path]);
};

const MinimalTiptapEditorViewer = ({ contents, fallback }: MinimalTiptapEditorViewerProps) => {
  _useStylesheet(`${process.env.NEXT_PUBLIC_CDN_URL}/assets/css/minimal-tiptap-editor.css`);

  if (!contents) return fallback || null;

  // XSS 방지: DOMPurify로 HTML 살균 후 contenteditable="true" 속성 제거
  const sanitizedContents = DOMPurify.sanitize(contents, { USE_PROFILES: { html: true } }).replace(
    /\s*contenteditable="true"/g,
    '',
  );

  return (
    <div className={EDITOR_CLASS_NAME}>
      <div className={PROSEMIRROR_CLASS_NAME} dangerouslySetInnerHTML={{ __html: sanitizedContents }} />
    </div>
  );
};

export default MinimalTiptapEditorViewer;
